import { Navigate } from "react-router-dom";
import { useAuth } from "@/hooks/useAuth";
import { roleHome } from "@/lib/roles";

/** Sends the signed-in user to the home surface for their highest-priority role. */
export function RoleHomeRedirect() {
  const { role, loading } = useAuth();
  if (loading) return null;
  const target = roleHome(role);
  return <Navigate to={target === "/app" ? "/app/shipper" : target} replace />;
}

export default RoleHomeRedirect;
